import { render, staticRenderFns } from "./newSale.vue?vue&type=template&id=020561bb&scoped=true&"
import script from "./newSale.vue?vue&type=script&lang=js&"
export * from "./newSale.vue?vue&type=script&lang=js&"
import style0 from "./newSale.vue?vue&type=style&index=0&id=020561bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020561bb",
  null
  
)

export default component.exports